import { render, staticRenderFns } from "./editPhoneModal.vue?vue&type=template&id=bdc8a008&scoped=true"
import script from "./editPhoneModal.vue?vue&type=script&lang=js"
export * from "./editPhoneModal.vue?vue&type=script&lang=js"
import style0 from "./editPhoneModal.vue?vue&type=style&index=0&id=bdc8a008&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc8a008",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdc8a008')) {
      api.createRecord('bdc8a008', component.options)
    } else {
      api.reload('bdc8a008', component.options)
    }
    module.hot.accept("./editPhoneModal.vue?vue&type=template&id=bdc8a008&scoped=true", function () {
      api.rerender('bdc8a008', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/accountManage/editPhoneModal.vue"
export default component.exports